import type { NextPage } from 'next'
import Head from 'next/head'

import { TermsPageSlice } from '@/slices/Help'
import { Layout } from '@/slices/Layout'
import { getLayoutProps } from '@/slices/Layout/global/layout'

const TermsPage: NextPage = () => {
  const layoutProps = getLayoutProps()

  return (
    <>
      <Head>
        <title>Terms and Conditions | Pixie World</title>
        <meta
          name="description"
          content="Read the terms and conditions for using PixieWorld personalized storybooks and services."
        />
      </Head>

      <Layout {...layoutProps}>
        <TermsPageSlice />
      </Layout>
    </>
  )
}

export default TermsPage
